import React, { Component } from 'react'
import {
  Mobile,
  Desktop,
  Tablet,
  Default,
  isNarrowDesktop,
} from '../media-queries'
import Helmet from 'react-helmet'
import InfoBlock from '../components/shared/infoBlock'
import SidePhoto from '../components/shared/sidePhoto'
import Mailto from 'react-mailto'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import AngleBracket from '../components/shared/angleBracket'

export default class UniversityPage extends Component {
  state = {
    isNarrowDesktop: isNarrowDesktop(),
    sideContainerHeight: 0,
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
    }
    this.setState({ sideContainerHeight: this.getHeight() })
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  handleResize = () => {
    if (this.state.isNarrowDesktop !== isNarrowDesktop()) {
      this.setState({ isNarrowDesktop: isNarrowDesktop() })
    }
    this.setState({ sideContainerHeight: this.getHeight() })
  }

  getHeight = () => {
    if (document && document.body) {
      return document.body.scrollHeight - 45 - 210
    }
  }

  render() {
    const { data } = this.props
    return (
      <div
        style={{
          fontFamily: "'Libre Franklin', 'sans serif'",
        }}
      >
        <Helmet
          title={`IMRD - ${data.name}`}
          meta={[
            { name: 'description', content: `partner university` },
            {
              name: 'keywords',
              content: `IMRD, coordinator, contact, general information, parter, partner university, ${
                data.name
              }`,
            },
          ]}
        />
        <div style={{ background: '#f7f7f7' }}>
          <Desktop>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                style={{
                  maxHeight: this.state.sideContainerHeight,
                  padding: `2rem ${
                    isNarrowDesktop() ? '5rem' : '7rem'
                  } 2rem 5rem`,
                  width: isNarrowDesktop() ? '67vw' : '55vw',
                }}
                className="scrollable"
                hidden={this.state.sideContainerHeight === 0}
              >
                <DefaultUniversity data={data} />
              </div>
              <SidePhoto
                minusHeight={2.5 * 18}
                sizes={data.photo.sizes}
                style={{
                  width: isNarrowDesktop() ? '33vw' : '45vw',
                  overflow: 'hidden',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  marginTop: 'calc(100vh * .6)',
                  marginLeft: 'calc(100vw - 240px)',
                }}
              >
                <UniversityButton link={data.link} image={data.image} />
              </div>
            </div>
          </Desktop>
          <Tablet>
            <div
              style={{
                padding: '2rem 4rem',
              }}
            >
              <DefaultUniversity data={data} />
              <div style={{ margin: '2rem 0', width: 300 }}>
                <UniversityButton
                  link={data.link}
                  text={data.name}
                  image={data.image}
                  style={{
                    padding: '0.5rem 1rem',
                  }}
                />
              </div>
            </div>
          </Tablet>
          <Mobile>
            <div
              style={{
                padding: '1rem 2rem',
              }}
            >
              <DefaultUniversity data={data} />
              <div style={{ margin: '2rem 0' }}>
                <UniversityButton
                  link={data.link}
                  text={data.name}
                  image={data.image}
                  style={{
                    padding: '0.5rem 1rem',
                  }}
                />
              </div>
            </div>
          </Mobile>
        </div>
      </div>
    )
  }
}

const DefaultUniversity = ({ data }) => (
  <div>
    <InfoBlock title={data.name} text={data.longText.internal.content} />
    {(data.generalInformationAddress || data.coordinatorAddress) && (
      <div
        style={{
          marginTop: '3rem',
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: '14px',
            marginBottom: '1.25rem',
            lineHeight: 0,
          }}
        >
          Contact:
        </div>
        <div style={{ lineHeight: 1.25, fontSize: '14px' }}>
          {data.generalInformationAddress && (
            <div>
              <div>general information:</div>
              <Mailto
                email={data.generalInformationAddress}
                style={{ color: '#549b54' }}
                obfuscate={true}
              >
                {data.generalInformationAddress}
              </Mailto>
              <br />
              <br />
            </div>
          )}
          {data.coordinatorAddress && (
            <div>
              <div>coordinator:</div>
              <Mailto
                email={data.coordinatorAddress}
                style={{ color: '#549b54' }}
                obfuscate={true}
              >
                {data.coordinatorAddress}
              </Mailto>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
)

const UniversityButton = ({ link, text, image, style }) => {
  let httpRoute = link
  if (link.indexOf('http') === 1) {
    httpRoute = `https://${link}`
  }
  return (
    <a href={httpRoute}>
      <div
        style={{
          background: 'white',
          minWidth: 240,
          padding: '0.5rem 4rem 0.5rem 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          ...style,
        }}
        className={'unselectable card'}
      >
        <Img sizes={image.sizes} style={{ width: 75, height: 75 }} />
        {text && <div>{text}</div>}
        <AngleBracket style={{ height: '1rem' }} />
      </div>
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/templates/university.js